import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Row } from 'react-bootstrap';
import TotalsWidget from './TotalsWidget';
import { toast } from 'react-toastify';

const Totals = () => {
    const { data, loading, error } = useSelector(s => s.glassTotals);

    if (error)
        toast.error('Something went wrong!', error);

    return (
        <Row className='h-100 align-items-center'>
            <TotalsWidget
                searchedData={data?.totals?.jobs}
                prevData={data?.totals?.previousJobsPercentage}
                //graph={data?.totals?.graphJobItems}
                title='Jobs'
                loading={loading} />
            <TotalsWidget
                searchedData={data?.totals?.units}
                prevData={data?.totals?.previousUnitsPercentage}
                //graph={data?.totals?.graphUnitItems}
                title='Units'
                loading={loading} />
        </Row>
    )
}

export default memo(Totals);